const indexPage = [
    {
        path: '/',
        component: () => import('@/views/indexPage'),
        name: 'indexPage',
        meta: { title: '后台', icon: '', affix: true },
    }
]

export default indexPage


// WEBPACK FOOTER //
// ./src/router/modules/indexPage.js